
export const handleUserInfo = (response: any) => {

    const data: dataType = {
        name: response.user != undefined && response.name != undefined ? response.name : null,
        email: response.user == null ? response.email : response.user != undefined && response.user.email != undefined ? response.user.email : null,
        userId: response.user != undefined && response.id != undefined ? response.id : null,
        number: response.user != undefined && response.number != undefined ? response.number : null,
        countryCode: response.user != undefined && response.country_code != undefined ? response.country_code : null,
        emailVerfiy: response.user != undefined && response.email_verified_at != undefined ? response.email_verified_at : null,
        walletAmount: response.wallet != undefined && response.wallet.amount != undefined ? response.wallet.amount : null,
        walletCreated: response.wallet != undefined && response.wallet.created_at != undefined ? response.wallet.created_at : null,
        walletDeleted: response.wallet != undefined && response.wallet.deleted_at != undefined ? response.wallet.deleted_at : null,
        walletId: response.wallet != undefined && response.wallet.id != undefined ? response.wallet.id : null,
        walletReward: response.wallet != undefined && response.wallet.reward != undefined ? response.wallet.reward : null,
        walletUpdated: response.wallet != undefined && response.wallet.updated_at != undefined ? response.wallet.updated_at : null,
        tapWalletId: response.meta != undefined && response.meta.tap_wallet_id != undefined ? response.meta.tap_wallet_id : null,
        tapBankId: response.meta != undefined && response.meta.tap_bank_account_id != undefined ? response.meta.tap_bank_account_id : null,
        tapCustomerId: response.tap_customer_id != undefined ? response.tap_customer_id : null,
        userInvoices: response.invoices != undefined && response.invoices.count != undefined ? response.invoices.count : null,
        userActiveStatus: response.active.status != undefined ? response.active.status : null,
        userActiveReason: response.active.reason != undefined ? response.active.reason : null,
        userCreated: response.created_at != undefined ? response.created_at : null,
        userCurrency: response.currency != undefined ? response.currency : null,
        userDob: response.dob != undefined ? response.dob : null,
        userFirstName: response.first_name != undefined ? response.first_name : null,
        userLastName: response.last_name != undefined ? response.last_name : null,
        userMiddleName: response.middle_name != undefined ? response.middle_name : null,
        userNationality: response.nationality != undefined ? response.nationality : null,
        userToken: response.token != undefined ? response.token : null,
        userGender: response.gender != undefined ? response.gender : null,
        userCountryId: response.country_id != undefined ? response.country_id : null,
        userCityId:  response.city_id != undefined ? response.city_id : null,
        userAreaId: response.area_id != undefined ? response.area_id : null,
        userAddress: response.address != undefined ? response.address : null,
        customerId: response.id != undefined ? response.id : null,
        userImage: response.image != undefined ? response.image : null,
    }
    return data;
}


export type dataType = {
    name:string;
    email:string
    userId:number
    number:string
    countryCode:string
    emailVerfiy:boolean
    walletAmount:string
    walletCreated:string
    walletDeleted:string
    walletId:number
    walletReward:any
    walletUpdated:string
    tapWalletId:number
    tapBankId:number
    tapCustomerId:number
    userInvoices:number
    userActiveStatus:boolean
    userActiveReason:string
    userCreated:string
    userCurrency:string
    userDob:string
    userFirstName:string
    userLastName:string
    userMiddleName:string
    userNationality:string
    userToken:string
    userGender:string
    userCountryId:number
    userCityId:number
    userAreaId:number
    userAddress:number
    customerId:number
    userImage:string
    
}